module.exports = __webpack_public_path__ + "img/⁠kumpulkan-reward.5435c40a.jpg";